export const MW_ERRORS = {
    ERROR_READ_DEVICE_DATA: {
        code: 'ERROR_READ_DEVICE_DATA',
    },
    ERROR_DEVICE_DISCONNECTED: {
        code: 'ERROR_DEVICE_DISCONNECTED',
    },
    ERROR_DEVICE_REQUEST_CANCELED: {
        code: 'ERROR_DEVICE_REQUEST_CANCELED',
    },
    ERROR_CONNECTION_NOT_FOUND: {
        code: 'ERROR_CONNECTION_NOT_FOUND',
    },
    ERROR_PAIRING: {
        code: 'ERROR_PAIRING',
    },
    ERROR_NOT_SUPPORTED_DEVICE: {
        code: 'ERROR_NOT_SUPPORTED_DEVICE',
    },
    ERROR_WRONG_DEVICE: {
        code: 'ERROR_WRONG_DEVICE',
    },
    ERROR_RECONNECT_CANCELED: {
        code: 'ERROR_RECONNECT_CANCELED',
    },
    ERROR_BLE_CLIENT_NOT_INITIALIZED: {
        code: 'ERROR_BLE_CLIENT_NOT_INITIALIZED',
    },
    ERROR_FWU_DOWNLOAD_OR_PARSE: {
        code: 'ERROR_FWU_DOWNLOAD_OR_PARSE',
    },
    ERROR_FWU_DOWNLOAD_URL_EMPTY: {
        code: 'ERROR_FWU_DOWNLOAD_URL_EMPTY',
    },
    ERROR_TOKEN_EXPIRED: {
        code: 'ERROR_TOKEN_EXPIRED',
    },
    ERROR_IOT_CONNECTION_GENERAL: {
        code: 'ERROR_IOT_CONNECTION_GENERAL',
    },
    ERROR_IOT_CONNECTION_TIMEOUT: {
        code: 'ERROR_IOT_CONNECTION_TIMEOUT',
    },
    ERROR_IOT_CONNECTION_DEVICE_DISCONNECTED: {
        code: 'ERROR_IOT_CONNECTION_DEVICE_DISCONNECTED',
    },
    ERROR_IOT_NO_ASSET_INFO: {
        code: 'ERROR_IOT_NO_ASSET_INFO',
    },
    ERROR_IOT_NO_ASSET_ID: {
        code: 'ERROR_IOT_NO_ASSET_ID',
    },
    ERROR_IOT_NO_REQUEST_ID: {
        code: 'ERROR_IOT_NO_REQUEST_ID',
    },
    ERROR_WRONG_DATA: {
        code: 'ERROR_WRONG_DATA',
    },
    ERROR_IOT_HOLDER_NOT_CONNECTED: {
        code: 'ERROR_IOT_HOLDER_NOT_CONNECTED',
    },
    ERROR_IOT_WRONG_DEVICE: {
        code: 'ERROR_IOT_WRONG_DEVICE',
    },
    ERROR_IOT_CUSTOM: {
        code: 'ERROR_IOT_CUSTOM',
    },
    ERROR_DEVICE_IN_SBL: {
        code: 'ERROR_DEVICE_IN_SBL',
    },
    ERROR_HOLDER_IN_SBL: {
        code: 'ERROR_HOLDER_IN_SBL',
    },
    ERROR_IOT_FLOW_ALREADY_IN_PROGRESS: {
        code: 'ERROR_IOT_FLOW_ALREADY_IN_PROGRESS',
    },
    ERROR_IOT_401: {
        code: 'ERROR_IOT_401',
    },
    ERROR_IOT_NO_FWU_INFO: {
        code: 'ERROR_IOT_NO_FWU_INFO',
    },
};
